import { useTabs } from 'hooks/useTabs';
import { useTranslation } from 'react-i18next';
import NotificationsList from './NotificationsList/NotificationsList';
import NotificationsForm from './NotificationsForm/NotificationsForm';
import './NotificationsManager.scss';

export const notificationTabs = {
  list: 'LIST',
  new: 'NEW',
  edit: 'EDIT',
} as const;

export const NotificationsManager: React.FC = () => {
  const { t } = useTranslation();
  const { tabsComponent, activeTab, setActiveTab } = useTabs({
    tabNames: Object.values(notificationTabs),
    getLabel: (tab) => t(`components:notifications_manager.tabs.${tab}`),
  });

  const content = () => {
    switch (activeTab) {
      case notificationTabs.list:
        return <NotificationsList setActiveTab={setActiveTab} />;
      case notificationTabs.edit:
      case notificationTabs.new:
        return <NotificationsForm onCancel={() => setActiveTab(0)} />;
      default:
        return null;
    }
  };

  return (
    <div className="notifications-manager">
      {tabsComponent}

      {content()}
    </div>
  );
};
